module.exports = "../../avatar.jpg";